export const ServerUrl = 'https://backend-aphh.onrender.com';
export const F_Size_for_Site = 18;